import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {TrainingService} from "./training.service";
import {Observable, ReplaySubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class FeedService {

  constructor(private trainingService: TrainingService, private httpClient: HttpClient) {
  }

  load(name: string): Observable<any> {
    const options = {params: new HttpParams().set('name', name)};

    return new Observable((observer) => {
      this.trainingService.load().subscribe(api => {
        console.log('FeedService.loading', name);
        this.httpClient.get(api.getRoute('feedUrl'), options).subscribe(value => {
          console.log('FeedService.loaded', name);
          observer.next(value);
        }, error => {
          observer.error(error);
          console.error(error);
        });
      });
    });
  }
}
